import type { Plugin } from 'vue'

import FocusTrap from 'primevue/focustrap'

const plugin = {
	install(app) {
		app.directive('focustrap', FocusTrap)
	},
} satisfies Plugin<unknown>

export { plugin as FocusTrapPlugin }
